import { Alert, Snackbar, AlertColor } from "@mui/material";
import React, { ReactNode, useState } from "react";

interface SnackbarAlertProps {
  type: AlertColor; // Alert severity: "error" | "info" | "success" | "warning"
  children: ReactNode;
}

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({ type, children }) => {
  const [open, setOpen] = useState(true);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity={type}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {children}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
